import Vue from 'vue'

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS

//////////////////////////////////////////////////////////////// Site drawer
import SiteDrawer from './plugins/site-drawer/index.js'
Vue.use(SiteDrawer)

//////////////////////////////////////////////////////////////// Scroll To
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 750,
    easing: "ease",
    offset: -150,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

//////////////////////////////////////////////////////////////// Bootstrap
import { ModalPlugin, CollapsePlugin } from 'bootstrap-vue'
Vue.use(ModalPlugin)
Vue.use(CollapsePlugin)

//////////////////////////////////////////////////////////////// Form validation
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

//////////////////////////////////////////////////////////////// Gallery Lightbox
// import {
//     Fancybox
// } from "@fancyapps/ui/src/Fancybox/Fancybox.js"
import galleryOptions from './imports/fancyOptions'
// Fancybox.bind("[data-fancybox]", galleryOptions)
import FancyBox from './plugins/fancy-box/index.js'
Vue.use(FancyBox, galleryOptions)

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS

//////////////////////////////////////////////////////////////// Sticky Header
import StickyElement from './components/sticky-element/index.vue'
Vue.component('sticky-element', StickyElement)

//////////////////////////////////////////////////////////////// Background Image
import BgImage from './components/bg-image/index.vue'
Vue.component('BgImage', BgImage)

//////////////////////////////////////////////////////////////// Background Video
import BgVideo from './components/bg-video/index.vue'
Vue.component('BgVideo', BgVideo)

//////////////////////////////////////////////////////////////// Text Wings
import TextWings from './components/text-wings/index.vue'
Vue.component('TextWings', TextWings)

//////////////////////////////////////////////////////////////// Select Dropdown
import vSelect from 'vue-select'
Vue.component('vSelect', vSelect)
vSelect.props.components.default = () => ({
    Deselect: {
        render: createElement => createElement(''),
    },
    OpenIndicator: {
        render: createElement => createElement('i', {
            class: {
                'icon-arrow-medium-down': true
            }
        }),
    }
});

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES

//////////////////////////////////////////////////////////////// Gsap
import Gsap from './directives/gsap/index.js'
Vue.directive('Gsap', Gsap)

/////////////////////////////////////////////////////////////////////////////////////////////////// APP

//////////////////////////////////////////////////////////////// Local
import Sticky from 'vue-sticky-directive'
const AgentsMap = () => import('./agents-map.js')
const RoutesFinder = () => import('./routes-finder.js')
const ContactFormSm = () => import('./contact-form-sm.js')
const ContactFormLo = () => import('./contact-form-lo.js')
import Animations from './animations.js'

import {
    devices
} from './imports/utils'

var app = new Vue({
    el: '#app',
    mixins: [Animations],
    components: {
        AgentsMap,
        RoutesFinder,
        ContactFormSm,
        ContactFormLo
    },
    directives: {
        Sticky
    },
    data() {
        return {
            // urlHash: window.location.hash,
            // lang: document.getElementById('app').getAttribute('lang'),
            isDevice: devices(),
            windowWidth: window.innerWidth,
        }
    },
    // watch: {
    //     urlHash(hash) {
    //         window.location.hash = hash;
    //     }
    // },
    methods: {
        // handleHashchange(event) {
        //     this.urlHash = location.hash;
        // },
        onResize() {
            this.windowWidth = window.innerWidth
        },
        animateMenu() {
            const ohs = document.querySelectorAll('.menu .oh-on-class')
            const reveals = document.querySelectorAll('.menu .reveal-on-class')
            const revealsLeft = document.querySelectorAll('.menu .reveal-left-on-class')

            if (this.$refs['menu'].open) {
                ohs.forEach(element => {
                    element.classList.add('animated')
                })

                reveals.forEach(element => {
                    element.classList.add('animated')
                })

                revealsLeft.forEach(element => {
                    element.classList.add('animated')
                })
            } else {
                ohs.forEach(element => {
                    element.classList.remove('animated')
                })

                reveals.forEach(element => {
                    element.classList.remove('animated')
                })

                revealsLeft.forEach(element => {
                    element.classList.remove('animated')
                })
            }
        }
    },
    created() {
        // var component = this;
        // window.addEventListener("hashchange", this.handleHashchange, {
        //     passive: true
        // })

        window.addEventListener("resize", this.onResize, {
            passive: false
        })

        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;')
    },
    destroyed() {
        window.removeEventListener("resize", this.onResize)
    }
})

// window.Laravel.vm = app;